/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineAbility } from "@casl/ability";
import { createContext } from "react";
import { createContextualCan } from "@casl/react";

export interface PermissionType {
  action: string;
  feature: string;
}

const cont: any = 'permission';

export const AbilityContext = createContext(cont);
export const Can = createContextualCan(AbilityContext.Consumer);

export const getAbility = (permissions: PermissionType[]) => {
  return defineAbility((can) => {
    permissions.forEach((ability: PermissionType) => {
      can(ability.action, ability.feature)
    });
  });
}
